"use client";

export default function TermeniPage() {
  return (
    <section className="bg-[#FDF9F5] text-[#264653] py-20 px-6">
      <div className="max-w-4xl mx-auto space-y-6">
        <h1 className="text-3xl font-bold mb-4">Termeni și condiții</h1>
        <p className="text-[#264653]/80">
          Bine ai venit pe platforma <strong>Mindtale</strong> – o soluție digitală dedicată
          sănătății mintale, care facilitează conectarea între terapeuți autorizați și clienți
          care doresc sprijin psihologic online.
        </p>

        <h2 className="text-xl font-semibold mt-8">1. Informații generale</h2>
        <p>
          Platforma Mindtale este operată de <strong>Zenyra Therapy SRL</strong>, cu sediul în România.
          Accesând și utilizând platforma, accepți acești termeni și condiții.
        </p>

        <h2 className="text-xl font-semibold mt-8">2. Scopul platformei</h2>
        <p>
          Mindtale oferă un spațiu digital care facilitează comunicarea dintre clienți și terapeuți
          licențiați. Platforma nu furnizează direct servicii medicale sau psihoterapeutice, ci
          acționează ca intermediar tehnologic.
        </p>

        <h2 className="text-xl font-semibold mt-8">3. Responsabilitatea utilizatorilor</h2>
        <p>
          Utilizatorii sunt responsabili de corectitudinea datelor oferite și de respectarea
          confidențialității în timpul sesiunilor. Mindtale nu este responsabilă pentru
          calitatea serviciilor furnizate de terapeuți.
        </p>

        <h2 className="text-xl font-semibold mt-8">4. Confidențialitate</h2>
        <p>
          Mindtale respectă confidențialitatea tuturor informațiilor transmise prin platformă.
          Toate datele sunt prelucrate în conformitate cu Regulamentul (UE) 2016/679 (GDPR)
          și cu Politica de confidențialitate.
        </p>

        <h2 className="text-xl font-semibold mt-8">5. Drepturile de autor</h2>
        <p>
          Conținutul, designul și elementele vizuale ale platformei sunt protejate prin drepturi
          de autor și nu pot fi copiate fără acordul scris al Zenyra Therapy SRL.
        </p>

        <h2 className="text-xl font-semibold mt-8">6. Limitarea răspunderii</h2>
        <p>
          Platforma Mindtale este un spațiu de facilitare și nu garantează rezultate terapeutice.
          În caz de urgență psihologică sau risc suicidar, te rugăm să contactezi imediat
          <strong> serviciile medicale de urgență (112)</strong>.
        </p>

        <h2 className="text-xl font-semibold mt-8">7. Modificări ale termenilor</h2>
        <p>
          Mindtale își rezervă dreptul de a actualiza acești termeni. Versiunea actualizată va fi
          disponibilă permanent pe această pagină.
        </p>

        <h2 className="text-xl font-semibold mt-8">8. Contact</h2>
        <p>
          Pentru întrebări legate de termeni și condiții, ne poți scrie la{" "}
          <a
            href="mailto:hello@mindtale.ro"
            className="text-[#E76F51] hover:underline"
          >
            hello@mindtale.ro
          </a>.
        </p>
      </div>
    </section>
  );
}
